export default __webpack_public_path__ + "static/media/4.df5a5702.png";